export default __webpack_public_path__ + "ce6d46416fb1b3daa29c7ca0bbe79418.svg";